export default "__VITE_ASSET__C6V$TK21__"